<template>
    <div class="center-page">
        <el-page-header style="margin-bottom: 20px;" @back="$router.back()"
                        :content="`${id?'编辑':'新增'}车辆`"></el-page-header>
        <el-form :model="addForm" :rules="rules" label-position="right" label-width="150px" ref="forms">
            <el-form-item label="封面照片：" prop="cover">
                <el-upload
                        action=""
                        class="avatar-uploader"
                        :http-request="uploadCover"
                        :show-file-list="false">
                    <img v-if="addForm.cover" :src="`/api/v1/file/${addForm.cover}`" class="avatar" alt="">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    <div slot="tip" class="color-red">文件大小1MB以内，支持JPG、GIF、PNG格式。</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="车辆照片：" required>
                <transition-group tag="div" name="drag" class="img-content">
                    <img @dragstart="handlerStart(item,index)"
                         @dragend="handlerEnd(item,index)"
                         @dragenter="handlerEnter(item,index)"
                         @click="delImg(index)"
                         v-for="(item,index) in addForm.image"
                         :key="item"
                         class="img-content-item" :src="`/api/v1/file/${item}`" alt="">
                    <el-upload
                            action=""
                            key="upload"
                            :http-request="uploadImage"
                            class="avatar-uploader"
                            :show-file-list="false">
                        <i slot="trigger" class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="color-red">文件大小1MB以内，支持JPG、GIF、PNG格式。</div>
                    </el-upload>
                </transition-group>
            </el-form-item>
            <el-form-item label="车辆名称：" prop="name">
                <el-input style="width: 50%;" v-model="addForm.name" placeholder="车辆名称"></el-input>
            </el-form-item>
            <el-form-item label="车辆座位数：" prop="seats">
                <el-input-number :min="1" :step="1" v-model="addForm.seats"></el-input-number>
            </el-form-item>
            <el-form-item label="车检有效期：" prop="driver_license_time">
                <el-date-picker
                        v-model="addForm.driver_license_time"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="驾照取得日期：" prop="inspection_period">
                <el-date-picker
                        v-model="addForm.inspection_period"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="每车价格：" prop="price">
                <el-input style="width: 30%;" v-model="addForm.price" placeholder="请输入每车价格">
                    <template slot="prepend"><span class="color-red">￥</span></template>
                </el-input>
            </el-form-item>
            <el-form-item label="最多行李数：" prop="price">
                <el-input style="width: 30%;" v-model="addForm.price" placeholder="请输入最多行李数">
                    <template slot="append">件</template>
                </el-input>
            </el-form-item>
            <el-form-item label="最大可载人数：" prop="min_number">
                <el-input-number :min="1" :step="1" v-model="addForm.min_number"></el-input-number>
            </el-form-item>
            <el-form-item label="接送区间：" prop="section1">
                <el-select v-model="addForm.section1" filterable>
                    <el-option v-for="(item,index) in cityList" :key="index" :value="item.id"
                               :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="接送机场：" prop="section2">
                <el-select v-model="addForm.section2" placeholder="请选择飞机场" filterable>
                    <el-option v-for="(item,index) in airport"
                               :key="index"
                               :label="item.name"
                               :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" v-loading="loading" @click="driverCarAdd">提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import {formVerify, delToast} from '@/utlis/decorators'

    export default {
        name: "addCar",
        data() {
            return {
                id: '',
                loading: false,
                addForm: {
                    cover: '',//封面图
                    image: [],//图片
                    name: '',
                    seats: 1,
                    driver_license_time: '',
                    inspection_period: '',
                    price: '',
                    min_number: 1,
                    section1: '',
                    section2: ''
                },
                rules: {
                    cover: [{required: true, message: '请上传封面', trigger: ['blur', 'change']}],
                    name: [{required: true, message: '请输入车辆名称', trigger: ['blur', 'change']}],
                    seats: [{required: true, message: '请输入车辆座位数', trigger: ['blur', 'change']}],
                    driver_license_time: [{required: true, message: '请选择车检有效期', trigger: ['blur', 'change']}],
                    inspection_period: [{required: true, message: '请选择驾照取得日期', trigger: ['blur', 'change']}],
                    price: [{required: true, message: '请输入每车价格', trigger: ['blur', 'change']}],
                    min_number: [{required: true, message: '请输入最低起载人数', trigger: ['blur', 'change']}],
                    section1: [{required: true, message: '请选择接送区间', trigger: ['blur', 'change']}],
                    section2: [{required: true, message: '请选择飞机场', trigger: ['blur', 'change']}],
                },
                start: '',
                startIndex: '',
                end: '',
                endIdnex: '',
                airport: []
            }
        },
        computed:{
            ...mapState(['cityList'])
        },
        created() {
            this.getLandlordAdd()
        },
        methods: {
            @delToast('是否删除该图片？')
            async delImg(index){
                this.addForm.image.splice(index, 1)
            },
            async uploadCover(e) {
                if (e.file.size / 1024 > 1024) {
                    return this.$message.warning('文件大小不能超过1M')
                }
                let form = new FormData();
                form.append('image', e.file);
                let [err, data] = await this.$api.uploadImageApi(form)
                if (data.code === 200) {
                    this.addForm.cover = data.result;
                }
            },
            async uploadImage(e) {
                if (e.file.size / 1024 > 1024) {
                    return this.$message.warning('文件大小不能超过1M')
                }
                let form = new FormData();
                form.append('image', e.file);
                let [err, data] = await this.$api.uploadImageApi(form)
                if (data.code === 200) {
                    this.addForm.image.push(data.result);
                }
            },
            handlerStart(item, index) {
                this.start = item
                this.startIndex = index
            },
            handlerEnd(item, index) {
                if (this.startIndex === this.endIdnex) return;
                this.addForm.image.splice(this.startIndex, 1, this.end);
                this.addForm.image.splice(this.endIdnex, 1, this.start);
            },
            handlerEnter(item, index) {
                this.end = item
                this.endIdnex = index
            },
            async getLandlordAdd() {
                let [e, data] = await this.$api.getLandlordAddApi();
                if (data.code === 200) {
                    this.airport = data.result.airport;
                }
            },
            @formVerify()
            async driverCarAdd(){
                this.loading = true;
                let [e, data] = await this.$api.driverCarAddApi(this.addForm);
                this.loading = false;
                if (data.code === 200) {
                    this.$message.success('提交成功！')
                    this.$router.back();
                } else {
                    this.$message.warning(data.error)
                }
            }
        },
    }
</script>

<style scoped lang="less">
    .img-content {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;

        .img-content-item {
            width: 150px;
            height: 150px;
            object-fit: cover;
            margin-right: 20px;
            margin-bottom: 20px;
        }
    }

    .drag-move {
        transition: 0.3s;
    }
</style>
